// extracted by mini-css-extract-plugin
module.exports = {"ColumnModule":"ColumnModule_ColumnModule__T8Aon"};